import { gql, TypedDocumentNode } from "@apollo/client";

export type GetInteractionInsightsResponse = {
  insights: {
    interactionInsights: string | null;
  };
};

export type GetInteractionInsightsVariables = {
  pgaId: string;
};

export const INTERACTION_INSIGHTS_QUERY: TypedDocumentNode<
  GetInteractionInsightsResponse,
  GetInteractionInsightsVariables
> = gql`
  query GetInteractionInsights($pgaId: ID!) {
    insights(pgaId: $pgaId) {
      interactionInsights
    }
  }
`;
